import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import moment from "moment";
import { DatePicker, Popconfirm } from "antd";
import ReactTable from "react-table";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, ButtonGroup } from "react-bootstrap";
import ReactTableFilterSelect from "components/custom/forms/react-table-filter-select";
import filterCaseInsensitive from "components/custom/forms/react-table-case-insensitive";
import EditReportLayout from "components/menu/master-files/report-builder/edit-modal";
import {
    closeCustomModal,
    openCustomModal
} from "components/custom/modals";
import {
    getReportLayouts,
    deleteReportLayout
} from "api/menu/master-files/report-builder/actions";

class ReportBuilder extends React.Component {
    dateFormat = "YYYY-MM-DD";

    constructor(props) {
        super(props);

        this.state = {
        };

        this.getColumns = this.getColumns.bind(this);
        this.deleteReportLayout = this.deleteReportLayout.bind(this);
        this.handleEdit = this.handleEdit.bind(this);

        this.props.getReportLayouts();
    }

    getColumns = () => [
        {
            Header: "Job",
            accessor: "job",
        },
        {
            Header: "Product",
            accessor: "product",
        },
        {
            Header: "From Date",
            id: "serviceFromDate",
            accessor: original => moment(original.serviceFromDate).format(this.dateFormat),
            Cell: ({ original }) => moment(original.serviceFromDate).format(this.dateFormat),
            Filter: ({ filter, onChange }) => (
                <DatePicker
                    format={this.dateFormat}
                    value={filter ? filter.value : null}
                    onChange={date => onChange(date)}
                    placeholder=""
                    className="d-block"
                />
            ),
            filterMethod: (filter, row) => {
                if (!filter.value) {
                    return true;
                }
                return moment(row.serviceFromDate).valueOf() >= moment(filter.value).valueOf();
            }
        },
        {
            Header: "To Date",
            id: "serviceToDate",
            accessor: "serviceToDate",
            Cell: ({ original }) => moment(original.serviceToDate).format(this.dateFormat),
            Filter: ({ filter, onChange }) => (
                <DatePicker
                    format={this.dateFormat}
                    value={filter ? filter.value : null}
                    onChange={date => onChange(date)}
                    placeholder=""
                    className="d-block"
                />
            ),
            filterMethod: (filter, row) => {
                if (!filter.value) {
                    return true;
                }
                return moment(row.serviceToDate).valueOf() <= moment(filter.value).valueOf();
            }
        },
        {
            Header: "Active?",
            id: "inactive",
            accessor: original => (original.inactive ? "No" : "Yes"),
            Cell: ({ original }) => (original.inactive ? "No" : "Yes"),
            Filter: ({ filter, onChange }) => (
                <ReactTableFilterSelect
                    currentValue={filter ? filter.value : ""}
                    onChange={value => onChange(value)}
                    style={{ width: "100%", height: "100%" }}
                    optionsObject={{
                        "": "Show All",
                        YES: "Yes",
                        NO: "No"
                    }}
                />
            )
        },
        {
            Header: "Actions",
            id: "actions",
            className: "d-flex justify-content-center align-items-center",
            filterable: false,
            width: 100,
            Cell: ({ original }) => (
                <ButtonGroup>
                    <Button
                        variant="warning"
                        size="sm"
                        onClick={() => this.handleEdit(original.reportId)}
                    >
                        <FontAwesomeIcon icon="pen" />
                    </Button>
                    <Popconfirm
                        title={`Delete "${original.description}"?`}
                        onConfirm={() => this.deleteReportLayout(original.reportId)}
                        placement="topRight"
                        okText="Yes"
                        cancelText="Cancel"
                    >
                        <Button variant="danger" size="sm">
                            <FontAwesomeIcon icon="times" />
                        </Button>
                    </Popconfirm>
                </ButtonGroup>
            )
        }
    ];

    deleteReportLayout = (reportId) => {
        this.props.deleteReportLayout(reportId);
    };

    handleEdit = (reportId = false) => {
        const modalObj = {
            id: "edit-report-layout",
            modalSettings: {
                size: "lg",
                style: {
                    top: 20,
                    width: "calc(100% - 40px)"
                },
            },
            header: reportId ? "Edit Report Layout" : "Create New Report Layout",
            children: (
                <React.Suspense fallback={<div className="m-2 text-center font-weight-bold">Loading...</div>}>
                    <EditReportLayout
                        reportId={reportId}
                        onCancel={() => this.props.closeCustomModal(modalObj)}
                    />
                </React.Suspense>
            ),
            handleClose: () => this.props.closeCustomModal(modalObj)
        };
        this.props.openCustomModal(modalObj);
    };

    render() {
        const {
            loading,
            reportLayouts
        } = this.props;

        return (
            <div className="dashboard">
                <div className="d-flex justify-content-between align-items-center mb-4">
                    <h3 className="mb-0">
                        Report Layouts
                    </h3>
                    <button
                        className="btn btn-success"
                        onClick={() => this.handleEdit()}
                    >
                        New Report Layout
                    </button>
                </div>
                <ReactTable
                    data={reportLayouts}
                    columns={this.getColumns()}
                    headerClassName="table-header"
                    showPagination={true}
                    defaultPageSize={20}
                    pageSizeOptions={[10, 20, 50, 100]}
                    resizable
                    className="-striped -highlight"
                    loading={loading}
                    filterable={true}
                    defaultFiltered={[
                        {
                            id: "inactive",
                            value: "YES"
                        }
                    ]}
                    defaultSorted={[
                        {
                            id: "completedDate",
                            desc: false
                        }
                    ]}
                    defaultFilterMethod={filterCaseInsensitive}
                    getNoDataProps = {() => ({
                        style: {
                            zIndex: 0
                        }
                    })}
                    style={{
                        height: "calc(100vh - 140px)",
                    }}
                />
            </div>
        );
    }
}

const mapStateToProps = state => ({
    reportLayouts: state.reportBuilder.reportLayouts,
    loading: state.reportBuilder.loading
});

const mapStateToDispatch = dispatch => ({
    openCustomModal: bindActionCreators(openCustomModal, dispatch),
    closeCustomModal: bindActionCreators(closeCustomModal, dispatch),

    getReportLayouts: bindActionCreators(getReportLayouts, dispatch),
    deleteReportLayout: bindActionCreators(deleteReportLayout, dispatch),
});

export default connect(
    mapStateToProps,
    mapStateToDispatch
)(ReportBuilder);
